import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";

export default function AIImpactSection({ data }) {
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("gray.800", "white");

  // Use technologies from API data directly
  const features = data?.technologies || [];
  
  // API server URL from environment variable with fallback
  const API_SERVER_URL = process.env.REACT_APP_API_URL;
  console.log("API_SERVER_URL:", API_SERVER_URL);
  
  // Helper function to construct image URL
  const getImageUrl = (imageData) => {
    if (!imageData || !imageData.url) return null;
    
    // If URL is already complete (starts with http), use as-is
    if (imageData.url.startsWith('http')) {
      return imageData.url;
    }
    
    // Otherwise, construct URL with base
    const baseUrl = API_SERVER_URL?.replace('/api', '') || 'http://localhost:1337';
    return `${baseUrl}${imageData.url}`;
  };


  return (
    <Box py={{ base: 12, md: 16 }}>
      <Container maxW="7xl" px={{ base: 4, md: 8 }}>
        {/* Header Section */}
        <VStack
          spacing={{ base: 4, md: 6 }}
          align="flex-start"
          mb={{ base: 6, md: 8 }}
        >
          <Heading
            as="h2"
            fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
            fontWeight="bold"
            color={headingColor}
            lineHeight="shorter"
          >
            {data?.titleDesc?.title}
          </Heading>
          <Text
            fontSize={{ base: "md", md: "lg" }}
            color={textColor}
            maxW="4xl"
            lineHeight="relaxed"
          >
            {data?.titleDesc?.description}
          </Text>
        </VStack>

        {/* Features Grid */}
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 4 }}
          spacing={{ base: 8, md: 10, lg: 12 }}
          maxW="6xl"
        >
          {features.map((feature, index) => {
           
            const imageUrl = getImageUrl(feature.image);
            
            return (
            <VStack
              key={index}
              spacing={{ base: 4, md: 6 }}
              align="flex-start"
              textAlign="left"
              p={{ base: 6, md: 8 }}
              borderRadius="xl"
              transition="all 0.3s ease"
              _hover={{
                shadow: "lg",
                transform: "translateY(-4px)",
              }}
            >
              {/* Icon Container */}
              <Box
                w="60px"
                h="60px"
                bg="blue.50"
                borderRadius="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
                overflow="hidden"
              >
                {feature.image ? (
                  <Image 
                    src={imageUrl}
                    alt={feature.title}
                    boxSize="35px"
                    objectFit="contain"
                    onLoad={() => console.log(`Image loaded: ${feature.title}`)}
                    onError={(e) => console.log(`Image failed to load: ${feature.title}`, e.target.src)}
                  />
                ) : (
                  <Box w="35px" h="35px" bg="#000B8C" borderRadius="md" />
                )}
              </Box>

              {/* Title */}
              <Heading
                as="h3"
                fontSize={{ base: "lg", md: "xl" }}
                fontWeight="bold"
                color={headingColor}
                lineHeight="tight"
              >
                {feature.title}
              </Heading>

              {/* Description */}
              <Text
                color={textColor}
                fontSize={{ base: "sm", md: "md" }}
                lineHeight="relaxed"
              >
                {feature.description}
              </Text>
            </VStack>
            );
          })}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
